module.exports = __webpack_public_path__ + "img/advantage3_2@2x.1b65aadc.png";